export function preloader() {
  const preloader = document.querySelector("#preloader");

  if (!preloader) {
    return;
  }

  preloader.classList.add('removed');
}